/**
 * WorksheetEditor.jsx - the GAT-B quote workbook's Project Info, WorkSheet,
 * Summary and Quote Data in one editor. Used by the Worksheet quote (Build
 * quote) and by a project's Budget tab, which is the won quote's worksheet:
 * the same inputs, priced by the same server engine (lib/worksheetEngine.js).
 *   ws / setWs   the worksheet ({ customer, start, days, billable, nonBillable,
 *                fixedFee?, engineers }) and its updater (value or fn)
 *   calc         the server's answer for it (cost figures only with 'cost-rates')
 *   staff        the staff directory (names, levels, types, locations - no pay)
 */
import { useState } from 'react';
import WorksheetSetup from './WorksheetSetup';
import WorksheetDays from './WorksheetDays';
import WorksheetSummary from './WorksheetSummary';
import { fixedFeeOf } from '../quotes/worksheetDraft';

export default function WorksheetEditor({ ws, setWs, settings, staff, calc, seesCosts, canOverride, readOnly }) {
  const [active, setActive] = useState(0);
  const upd = (v) => setWs((w) => (typeof v === 'function' ? v(w) : v));
  return (
    <>
      <WorksheetSetup
        ws={ws}
        setWs={upd}
        settings={settings}
        staff={staff}
        calc={calc}
        seesCosts={seesCosts}
        canOverride={canOverride}
        readOnly={readOnly}
        active={active}
        setActive={setActive}
      />
      <WorksheetDays
        ws={ws}
        setWs={upd}
        settings={settings}
        calc={calc}
        seesCosts={seesCosts}
        readOnly={readOnly}
        active={active}
        setActive={setActive}
      />
      <WorksheetSummary
        calc={calc}
        seesCosts={seesCosts}
        readOnly={readOnly}
        fixedFee={fixedFeeOf(ws, settings)}
        onFixedFee={(list) => upd((w) => ({ ...w, fixedFee: list }))}
      />
    </>
  );
}
